module.exports = __webpack_public_path__ + "img/GBR.03008bd6.svg";